var render, staticRenderFns
import script from "./read-text.vue?vue&type=script&lang=js"
export * from "./read-text.vue?vue&type=script&lang=js"
import style0 from "./read-text.vue?vue&type=style&index=0&id=5d359664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports